import { regex } from './regex.validator';

export function uuid(allowEmpty = true) {
    return regex(/^(\{{0,1}([0-9a-fA-F]){8}-([0-9a-fA-F]){4}-([0-9a-fA-F]){4}-([0-9a-fA-F]){4}-([0-9a-fA-F]){12}\}{0,1})$/, allowEmpty);
}
